import { useCallback, useMemo } from 'react';
import { getRouteApi } from '@tanstack/react-router';
import type { PcmpMisBatchProposalsParams, PcmpMisBatchSearch } from '../types/pcmpMis.types';
import { usePcmpQueueFilters } from './usePcmpQueueFilters';

const route = getRouteApi('/_auth/pcmp/mis/batches/$batchNo/');

/** A batch's members: the queue filters, paging and "show all members". */
export function usePcmpMisBatchFilters() {
  const { batchNo } = route.useParams();
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const setSearch = useCallback(
    (update: (prev: PcmpMisBatchSearch) => PcmpMisBatchSearch) => {
      void navigate({ search: update });
    },
    [navigate],
  );

  const queue = usePcmpQueueFilters(search, setSearch);
  const { appliedFilters, page, limit } = queue;
  const showAll = search.showAll ?? false;

  const params = useMemo<PcmpMisBatchProposalsParams>(
    () => ({ ...appliedFilters, page, limit, showAll: showAll || undefined }),
    [appliedFilters, page, limit, showAll],
  );

  const setShowAll = useCallback(
    (next: boolean) => {
      setSearch((prev) => ({ ...prev, showAll: next || undefined, page: undefined }));
    },
    [setSearch],
  );

  return { ...queue, batchNo, showAll, params, setShowAll };
}
